import React from 'react';
import { Link2, FileText, Image as ImageIcon, Clock, ChevronLeft } from 'lucide-react';
import { API_BASE_URL } from '../config';
import './HistorySidebar.css';

const HistorySidebar = ({ history, isOpen, activeId, onSelect, onClose }) => {
    const formatTime = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);

        if (diffInSeconds < 60) return 'Just now';
        if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
        if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
        return date.toLocaleDateString();
    };

    const getThumbnail = (item) => {
        // Prioritize persistent thumbnail_url if available
        if (item.thumbnail_url) {
            return (
                <img
                    src={item.thumbnail_url}
                    className="item-thumbnail"
                    alt=""
                />
            );
        }

        // Fallback for older image uploads
        if (item.type === 'image' && item.media_id) {
            return (
                <img
                    src={`${API_BASE_URL}/media/${item.media_id}`}
                    className="item-thumbnail"
                    alt=""
                />
            );
        }

        switch (item.type) {
            case 'link': return <Link2 size={16} />;
            case 'image': return <ImageIcon size={16} />;
            default: return <FileText size={16} />;
        }
    };

    const getScoreColor = (score, label) => {
        if (label === 'Unverified') return '#8A8F98'; // neutral gray
        if (label === 'Disputed') return '#C99A3B';   // amber
        if (label === 'Developing') return '#4A73B0'; // blue
        if (score >= 71) return '#4E8D5B';
        if (score >= 31) return '#C99A3B';
        return '#B5533A';
    };
    const itemLabel = (item) => item.verdict_full?.verdict_label
        || (typeof item.verdict === 'string' ? item.verdict : item.verdict?.verdict_label);

    return (
        <aside className={`history-sidebar ${!isOpen ? 'closed' : ''}`}>
            <div className="history-header">
                <h2>History</h2>
                <button className="logout-trigger" onClick={onClose} title="Close History">
                    <ChevronLeft size={20} />
                </button>
            </div>

            <div className="history-list">
                {history.length === 0 ? (
                    <div className="history-empty">
                        <Clock size={32} style={{ opacity: 0.2, marginBottom: '12px' }} />
                        <p>No recent searches</p>
                    </div>
                ) : (
                    history.map((item) => (
                        <div
                            key={item.id}
                            className={`history-item ${activeId === item.id ? 'active' : ''}`}
                            onClick={() => onSelect(item)}
                        >
                            <div className="item-icon">
                                {getThumbnail(item)}
                            </div>
                            <div className="item-info">
                                <div className="item-text">{item.text || 'Untitled Query'}</div>
                                <div className="item-meta">
                                    <span className="item-time">{formatTime(item.timestamp)}</span>
                                    <span
                                        className="item-score-badge"
                                        style={{
                                            background: `${getScoreColor(item.truth_score, itemLabel(item))}20`,
                                            color: getScoreColor(item.truth_score, itemLabel(item))
                                        }}
                                    >
                                        {item.truth_score}%
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </aside>
    );
};

export default HistorySidebar;
